import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import LabelForm from './LabelForm';
import { Edit, CloudDownloadRounded, AddCircleOutlineRounded } from '@mui/icons-material';
import { IconButton, Grid, Box } from '@mui/material';
import LabelSingle from './LabelSingle';
import SearchBar from '../../common/SearchBar';

class LabelsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        selected: {},
        selectedLabel: {},
        searchValue: "",
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        // if(isEmpty(this.props.LABELS)){
        //     this.props.fetchLabels()
        // }
    }

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openUpdate: false,
            openDetails: false,
            selected: {},
            selectedLabel: {},
        });
    };    

    getLabelsList = () => {
        const { rowsPerPage, page, searchValue } = this.state;
        const { LABELS } = this.props;
        if (!isEmpty(LABELS)){
            let list = Object.values(LABELS)
            if( !isEmpty(searchValue) ){
                list = list.filter( label => label.label_name.toLowerCase().includes(searchValue) );
            }

            // return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item =>
            return list.map(item => (
                <TableRow hover key={item.label_id} className="">
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedLabel: item})}
                    >{item.label_name}</TableCell>                                                   
                    <TableCell>
                        <IconButton 
                            size="small" 
                            onClick={ () => this.setState({openUpdate: true, selected: item}) }
                        >
                            <Edit />
                        </IconButton>    
                    </TableCell>                                                   
                </TableRow>
            ) )
        }
    }

    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }

    render() {
        const { openForm, rowsPerPage, page, openUpdate, selected, openDetails, selectedLabel } = this.state;
        const { LABELS } = this.props;
        return (
            <div>
                {openForm &&
                    <LabelForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openUpdate && !isEmpty(selected) &&
                    <LabelForm 
                        update 
                        label={selected} 
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDetails && !isEmpty(selectedLabel) &&
                    <LabelSingle
                        open={openDetails} 
                        label={selectedLabel}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
              
                <Typography variant="h6" id="tableTitle">
                    Liste des Labels
                </Typography>

                <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                    <SearchBar 
                        handleChange={this.handleChange} 
                        label="Label"
                        searchValue={this.state.searchValue}
                    />
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        onClick={() => this.setState({ openForm: true })} 
                        title="Nouveau Label"
                        startIcon={<AddCircleOutlineRounded />}
                    >
                        Ajouter
                    </Button>
                    <IconButton color="primary" onClick={ () => this.props.handleDownload("/extract/labels", "MJB_labels.csv") } disabled={this.props.downloading}>
                        <CloudDownloadRounded />
                    </IconButton>
                </Box>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom</TableCell>
                            <TableCell>Modifier</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.getLabelsList()}
                    </TableBody>
                    {/* {size(LABELS) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 15]}
                                    colSpan={2}
                                    count={size(LABELS)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table> 
            </div>
        );
    }
}

export default LabelsList;